<template>
  <div class="label-wrapper body-s-high">
    {{ label }} {{ required ? '*' : '' }}
    <BaseTooltip
      v-if="info"
      :content="info"
      placement="top"
    >
      <BaseIcon
        color="var(--blueberry-1000)"
        icon="fa-regular fa-info-circle"
      />
    </BaseTooltip>
  </div>
</template>

<script lang="ts">
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle as farInfoCircle } from '@fortawesome/pro-regular-svg-icons'

library.add(farInfoCircle)

import BaseTooltip from './BaseTooltip.vue'
import BaseIcon from './BaseIcon.vue'

export default {
  name: 'InputLabel',
  components: {
    BaseTooltip,
    BaseIcon,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    info: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.label-wrapper {
  display: flex;
  align-items: center;
  gap: var(--space-1);
}
</style>
